import './CountryPage.css';

export const Programs = ({ country }) => {
    return (
        <div className="main-content">
            <section className="programs-duration">
                <h2>Programs and their duration in { country.name }</h2>
                <div className="table-container">
                    <table className="programs-table">
                        <thead>
                            <tr>
                                <th>Programs</th>
                                <th>Duration</th>
                            </tr>
                        </thead>
                        <tbody>
                            { country.programs.map((program) => (
                                <tr>
                                    <td>{ program.name }</td>
                                    <td>{ program.duration }</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="popular-programs">
                <h2>Popular programs to study in { country.name }</h2>
                <p>{ country.popularPrograms.title }</p>
                <div className="programs-grid">
                    { country.popularPrograms.programs.map((program, index) => (
                        <div key={index} className="program-item">{ program }</div>
                    ))}
                </div>
            </section>
        </div>
    )
}